// extracted by mini-css-extract-plugin
module.exports = {"ImageSide":"ImageSide_ImageSide__3IWGo","Image-info":"ImageSide_Image-info__3rDc2","Image-works":"ImageSide_Image-works__uhL_O","Image-purpose":"ImageSide_Image-purpose__1pNpq"};